import { QuickFiltersProvider } from "../../contexts/HeaderExtrasContext"   // s42: sahifa filtrlari Фильтр oynasida
import { refreshAccessToken } from "../../utils/config"   // s87
import decodeJwt from "../../utils/decodeJwt"   // s87
import React, { lazy, Suspense, useContext, useEffect, useLayoutEffect } from "react"
import { Layout } from "antd"
import Sidebar from "./Sidebar"
import Main from "./Main"
import { TitleProvider } from "../../contexts/TitleContext"

import "./index.less"
import { Router } from "react-router-dom"
import { AuthActions, AuthContext } from "../../contexts/auth/AuthContext"
import history from "../../services/history"
import Auth from "../../pages/auth"
import WarehouseBoardPublic from "../../pages/warehouseBoard/Public"   // tog'a #3457/#3460: omborda monitor — login'siz tablo
import DeliveryConfirmPublic from "../../pages/deliveryConfirm"   // tog'a 1179 (2026-09-04): ochiq tasdiq sahifasi
import Preloader from "../spinners/Preloader"
import { RENEW_TOKEN } from "../../rest-api/mutations/renewToken"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import Header2 from "./HeaderHome"
import { ThemeContext } from "../../contexts/ThemeContex"
import { useMutation } from "@tanstack/react-query"
import isValidJwt from "../../utils/isValidJwt"
import AIChatDrawer from "../../components/aiChat/AIChatDrawer"
import GlobalScanListener from "../../components/scanner/GlobalScanListener"   // tog‘a #2065 W1: bitta skaner tinglovchisi
import TenantViewBar from "./TenantViewBar"
import { useDragScroll } from "../../utils/useDragScroll"

// tog'a #3563 2-qism (2026-10-07): «Стать партнёром» — login'siz ariza formasi (/apply) va holati (/apply/<token>); alohida chunk
const PartnerApplyPublic = lazy(() => import("../../pages/partnerApply"))
// tog'a #3799: ommaviy oferta — login'siz sahifa (/offer) va hamkor admini uchun kirishda tasdiq
const OfferPublicPage = lazy(() => import("../../components/offer/Offer"))
// tog'a #342 / katalog #6024 (2026-10-29): ilovasiz haydovchi havolasi (/driver/<token>) — login'siz
const DriverLinkPublic = lazy(() => import("../../pages/driverLink"))
const OfferGate = lazy(() => import("../../components/offer/Offer").then((m) => ({ default: m.OfferGate })))

export default function AppLayout() {
  // Tog'a (guruh #737): barcha bo'lim jadvallarini sichqoncha bilan ushlab surish — bir marta, butun ilova uchun
  useDragScroll()
  const { authState, authDispatch } = useContext(AuthContext)
  const { themeState } = useContext(ThemeContext)
  const screens = useBreakpoint()
  const { mutate } = useMutation(RENEW_TOKEN, {
    onSuccess: (data) => {
      if (!data?.accessToken) {
        authDispatch({ type: AuthActions.SING_OUT })
        return
      }
      // Boshliq (2026-09-04): avval BUTUN authState qayta yozilardi — token yangilanishi lokal sozlamalarni
      // (masalan ovoz tanlovi) eski qiymatga qaytarardi. Endi faqat tokenlar va localStorage'dagi joriy user.
      let currentUser: any = authState?.user
      try { const ls = JSON.parse(localStorage.getItem("user") || "null"); if (ls) currentUser = ls } catch {}
      authDispatch({
        type: AuthActions.SIGN_IN,
        payload: {
          ...authState,
          user: currentUser,
          accessToken: data?.accessToken,
          refreshToken: data?.refreshToken,
        },
      })
    },
    onError: () => {
      authDispatch({ type: AuthActions.SING_OUT })
    },
  })

  // s87 (Boshliq 2026-09-09, token 60 daqiqa): (a) config.ts jim yangilaganda holatni ham yangilaymiz;
  // (b) muddat tugashiga 5 daqiqa qolganda AVTOMAT yangilaymiz — foydalanuvchi hech narsa sezmaydi.
  useEffect(() => {
    const onRenewed = (e: any) => {
      const d = e?.detail || {}
      if (!d.accessToken) return
      let currentUser: any = authState?.user
      try { const ls = JSON.parse(localStorage.getItem("user") || "null"); if (ls) currentUser = ls } catch {}
      authDispatch({ type: AuthActions.SIGN_IN, payload: { ...authState, user: currentUser, accessToken: d.accessToken, refreshToken: d.refreshToken } })
    }
    window.addEventListener("crm-token-renewed", onRenewed)
    const tick = setInterval(() => {
      try {
        const t = localStorage.getItem("accessToken")
        if (!t || !localStorage.getItem("refreshToken")) return
        const exp = Number(decodeJwt(t)?.exp || 0) * 1000
        if (exp && exp - Date.now() < 5 * 60 * 1000) refreshAccessToken()
      } catch { /* jim */ }
    }, 60 * 1000)
    return () => { window.removeEventListener("crm-token-renewed", onRenewed); clearInterval(tick) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useLayoutEffect(() => {
    if (
      !authState.accessToken ||
      !authState.refreshToken ||
      !authState.isAuthenticated
    ) {
      authDispatch({ type: AuthActions.SING_OUT })
      return
    }

    // Only renew token if access token has actually expired
    if (!isValidJwt(authState.accessToken)) {
      mutate({
        accessToken: authState.accessToken,
        refreshToken: authState.refreshToken,
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // Dark v3 (2026-08-31): ESKI '.dark' klass mexanizmi ranglarni buzardi
    // ("qusvoryapti") — o'chirildi. Yagona dark: theme.ts (data-theme + Telegram
    // palitrasi). Qolgan legacy klass bo'lsa ham tozalab qo'yamiz.
    document.getElementById("darkBleck")?.classList.remove("dark")
    document.getElementById("root")?.classList.add("apply-font")
  }, [themeState.currentTheme])

  return (
    <div className="WrapperProject">
      <Router history={history}>
        {/* tog'a 1179 (2026-09-04): qabul qiluvchi havola orqali tasdiqlaydi — login talab qilinmaydi */}
        {window.location.pathname.startsWith("/delivery/confirm/") ? (
          <DeliveryConfirmPublic />
        ) : window.location.pathname.startsWith("/driver/") ? (
          <Suspense fallback={<Preloader />}>
            <DriverLinkPublic />
          </Suspense>
        ) : window.location.pathname.startsWith("/board/") ? (<WarehouseBoardPublic />) : /^\/apply(\/|$)/.test(window.location.pathname) ? (
          <Suspense fallback={<Preloader />}>
            <PartnerApplyPublic />
          </Suspense>
        ) : /^\/offer\/?$/.test(window.location.pathname) ? (
          <Suspense fallback={<Preloader />}>
            <OfferPublicPage />
          </Suspense>
        ) : authState.isAuthenticated ? (
          <TitleProvider>
            <QuickFiltersProvider>
            <Layout>
              <Sidebar />
              <Layout
                className={`site-layout ${
                  !screens.lg ? "site-layout-mobile" : ""
                }`}
              >
                <Header2 />
                {/* 334-xabar: kuzatuv rejimidan chiqish HAR sahifada ko'rinishi shart */}
                <TenantViewBar />
                <Main />
              </Layout>
              <AIChatDrawer />
              <GlobalScanListener />
              <Suspense fallback={null}><OfferGate /></Suspense>
            </Layout>
            </QuickFiltersProvider>
          </TitleProvider>
        ) : (
          <Auth />
        )}
      </Router>
    </div>
  )
}
